import { ref, watchEffect } from 'vue'
import { useLoadWidgetObjectTypes } from './api.ts'

export const useModel = () => {
  const items = ref<{ name: string; id: number; is_system: boolean }[]>([])

  /**
   * Функция загрузки данных
   */
  const loadData = () => {
    const result = useLoadWidgetObjectTypes()

    watchEffect(() => {
      if (result.data.value) {
        items.value = result.data.value.data
      }
    })

    return result
  }

  return {
    items,

    loadData,
  }
}
